import { Notyf } from 'notyf'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

const Methods = {

    watch:{

        async 'form_data.building_id'(val)
        {
            this.loader(true);

            if(val)
            {
                let http_request = {
                    id: val,
                    type_request: 'building',
                }

                const response = await this.post(`${this.rest_api_general}/buildings_levels_areas`, http_request);

                if(response.status)
                {
                    if(response.data.length)
                    {
                        this.array_options.level_id = response.data
                        this.form_data.level_id = ''
                        this.form_data.area_id = ''
                        notyf.success('Levels available')
                    }
                    else
                    {
                        this.array_options.level_id = []
                        this.array_options.area_id = []
                        this.form_data.level_id = ''
                        this.form_data.area_id = ''
                        notyf.error('No Levels available')
                    }

                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options.level_id = []
                this.array_options.area_id = []
                this.form_data.level_id = ''
                this.form_data.area_id = ''
            }

            this.loader();
        },

        async 'form_data.level_id'(val)
        {
            this.loader(true);
            if(val)
            {
               
                let http_request = {
                    id: val,
                    type_request: 'level',
                }

                const response = await this.post(`${this.rest_api_general}/buildings_levels_areas`, http_request);

                if(response.status)
                {
                    if(response.data.length)
                    {
                        this.array_options.area_id = response.data
                        this.form_data.area_id = ''
                        notyf.success('Areas available')
                    }
                    else
                    {
                        this.array_options.area_id = []
                        this.form_data.area_id = ''
                        notyf.error('No areas available')
                    }

                }
                else
                {
                    this.error_handling(response)
                }
            }
            else
            {
                this.array_options.area_id = []
                this.form_data.area_id = ''

            }
            this.loader();
        },


    },

    methods: {

        returnedRoomsToParent()
        {
            const selection = this.$refs.advanced_search.returnedRoomsToParent();
            selection.unchecked_items = selection.unchecked_items.map(item => item.project_schedulers_id)
            this.rooms_to_parent = selection
        },
        
    }

}

export default Methods